import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import {
  getBoundaryStyle,
  getBoundaryTypes,
  getWorkingBoundaryPath,
  updateBoundaryStyle,
} from 'ducks/boundaries'
import withStore from '../../../../withStore'
import ToggleSwitch from '../../../../Utilities/ToggleSwitch'

const BoundariesList = ({ parent, isWorkingInUSBoundary }) => {
  const dispatch = useDispatch()
  const NONE_VALUE = 'none'
  const workingBoundaryPath = useSelector(getWorkingBoundaryPath)
  const boundaryTypes = useSelector((state) =>
    getBoundaryTypes(state, workingBoundaryPath)
  )
  const boundaryStyle = useSelector((state) =>
    getBoundaryStyle(state, workingBoundaryPath)
  )
  const [activeItemKey, setActiveItemKey] = useState(null)
  const isChecked = activeItemKey !== NONE_VALUE
  const key = boundaryTypes[0]?.key
  useEffect(() => {
    if(!boundaryStyle) {
      // TODO: better way to set default selection
      setActiveItemKey(key)
    }
    // update selected value if boundaryStyle changes
    if(boundaryStyle && boundaryStyle !== activeItemKey) {
      setActiveItemKey(boundaryStyle)
    }
  }, [boundaryStyle,key, activeItemKey])

  if(!boundaryTypes) {
    return null
  }

  const handleOptionSelect = (selectElement) => {
    debug('handleOptionSelect - e.currentTarget: ', selectElement)
    const selectedOption = selectElement.options[selectElement.selectedIndex]
    const optionType = selectedOption.dataset.set
    if(!optionType || optionType === activeItemKey) {
      return
    }
    setActiveItemKey(optionType)
    dispatch(updateBoundaryStyle(workingBoundaryPath, optionType))
  }

  const handleToggle = () =>{
    let defaultOption = boundaryTypes[0]?.key
    if(isChecked){
      defaultOption = boundaryTypes.at(-1)?.key
    }
    setActiveItemKey(defaultOption)
    dispatch(updateBoundaryStyle(workingBoundaryPath, defaultOption))
  }

  const menuItems = boundaryTypes?.map((type) => {
    return (
      <option
        key={type.key}
        value={type.name}
        className="boundary"
        data-set={type.key}
        data-skip-pjax={1}
      >
        {type.name}
      </option>
    )
  })

  const activeItemName = boundaryTypes.find(
    (boundaryType) => boundaryType.key === activeItemKey
  )?.name

  const displayBounds = activeItemName === 'None' ? 'Bounds' : activeItemName

  // Layers Modal
  if(!isWorkingInUSBoundary && parent === 'map-layers') {
    return (
      <div id="boundaries-list">
        <div className="layers-unavailable">
          <i className="fas fa-exclamation-circle margin-right-md"></i>
          <span className="bold">
            Additional boundary options are available within the US.
          </span>
        </div>
      </div>
    )
  }

  // Overview Pane
  if(!isWorkingInUSBoundary && parent !== 'map-layers') {
    return null
  }

  return (
    <>
    <div id="boundaries-list" className="map-options-content">
    <div
            className={'toggle-form-group'}>
            <label htmlFor="show-legend" className="form-label">
            Sub-Boundaries:
              </label>

            <ToggleSwitch
              id="show-boundaries"
              size="medium"
              checked={isChecked}
              onChange={handleToggle}
              />

      </div>
      <select
        id="boundariesSelector"
        className="toggle-form-group rounded form-control"
        value={displayBounds}
        onChange={(e) => handleOptionSelect(e.currentTarget)}
      >
        {menuItems}
      </select>
    </div>
    </>
  )
}

BoundariesList.propTypes = {
  parent:                  PropTypes.string,
  isWorkingInUSBoundary:   PropTypes.bool
}

export default withStore(BoundariesList)
